module.exports = __webpack_public_path__ + "static/media/phone_ru.1edac876.png";